import {Injectable,} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Rx';
import {FlatManagerService} from '../service/flat-manager.service';
import {Flat} from '../models/flat.model';

@Injectable()
export class FlatResolver implements Resolve<Flat> {
  constructor(private articlesService: FlatManagerService) {
  }

  resolve(route: ActivatedRouteSnapshot,
          state: RouterStateSnapshot): Observable<any> {

    return this.articlesService.getFlat(route.params['id']);

  }
}
